import React, { useEffect, useRef } from "react";
import "./App.css";
import {
  AppShell,
  Field,
  Form,
  FormLayout,
  LoadingSpinner,
  Navbar,
  NavbarBrand,
  NavbarContent,
  NavbarItem,
  Select,
  SelectButton,
  SelectList,
  useSnackbar,
} from "@saas-ui/react";

import { Button, Box, Container } from "@chakra-ui/react";
import { ReactTagManager } from "react-gtm-ts";
import FeatureDescription from "./components/FeatureDescription";

const tagManagerArgs = {
  code: "GTM-WZQPMC7",
};

function App() {
  ReactTagManager.init(tagManagerArgs);
  const intercomInitialized = useRef(false);
  const BASE_URL = "https://wix.certifiedcode.io/ecwid-readable";

  const snackbar = useSnackbar();
  const [isEnabled, setEnabled] = React.useState(false);
  const [instance, setInstance] = React.useState({} as any);
  const [config, setConfig] = React.useState({} as any);

  useEffect(() => {
    try {
      // Initialize the application
      window.EcwidApp.init({
        app_id: "wcag-accessibility", // client_id of your application
        autoloadedflag: true,
        autoheight: false,
      });

      getInstance();
      getSettings();

      window.EcwidApp.setSize({ height: 800 });
      console.log(
        // get the height of the window
        window.innerHeight
      )

      const checker = setInterval(() => {
        getInstance();
      }, 10000);

      return () => {
        clearInterval(checker);
      };
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    if (!intercomInitialized.current && instance.intercomToken && instance.storeProfile && instance.app) {
      const name = instance.storeProfile.account.accountName;
      const registrationDate = new Date(
        instance.storeProfile.account.registrationDate
      );
      const created_at = Math.floor(registrationDate.getTime() / 1000);
      const phone = instance.storeProfile.company.phone;
      const email = instance.storeProfile.account.accountEmail;
      const utm_source = instance.app.client_id;
      const options = {
        email,
        name,
        created_at,
        phone,
        user_hash: instance.intercomToken,
        utm_source,
      };
      window.Intercom("boot", options);
      intercomInitialized.current = true;
    }
  }, [instance]);

  function setSettings(isEnabled?: boolean) {
    return fetch(
      BASE_URL +
        "/_functions/@certifiedcode/ecwid-repluggable-backend/settings",
      {
        method: "POST",
        headers: {
          Authorization: new URLSearchParams(window.location.search).get(
            "payload"
          )!,
        },
        body: JSON.stringify({
          isEnabled,
          config,
        }),
      }
    )
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        setConfig(data.config);
        setEnabled(data.isEnabled);
        return Promise.resolve();
      })
      .catch(() => {
        return Promise.reject();
      });
    // } else {
    //   setIsUpgradeModalOpen(true)
    // }
  }

  function getInstance() {
    fetch(
      BASE_URL + "/_functions/@certifiedcode/ecwid-repluggable-backend/auth",
      {
        headers: {
          Authorization: new URLSearchParams(window.location.search).get(
            "payload"
          )!,
        },
      }
    )
      .then((response) => response.json())
      .then((payload) => {
        setInstance(payload);
        window.EcwidApp.ready();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  function getSettings() {
    fetch(
      BASE_URL +
        "/_functions/@certifiedcode/ecwid-repluggable-backend/settings",
      {
        method: "GET",
        headers: {
          Authorization: new URLSearchParams(window.location.search).get(
            "payload"
          )!,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        setEnabled(data.isEnabled);
        if (data.config) {
          setConfig(data.config);
        }
      })
      .catch(() => {});
  }

  return (
    <AppShell
      navbar={
        <Navbar>
          <NavbarBrand>Readable: WCAG Accessibility</NavbarBrand>
          <NavbarContent justifyContent="flex-end" spacing="2">
            <NavbarItem>
              {instance.store_id ? (
                !instance?.subscription ? (
                  <Button
                    className="btn btn-medium btn-primary"
                    variant="primary"
                    as="a"
                    href={
                      instance?.storeProfile
                        ? encodeURI(
                            "https://www.certifiedcode.us/upgrade/apps?checkout=" +
                              JSON.stringify({
                                settings: {
                                  allowLogout: false,
                                  allowDiscountRemoval: false,
                                },
                                items: [
                                  {
                                    priceId: "pri_01jj785705g4ys9fzvdd5hx7j4",
                                    quantity: 1,
                                  },
                                ],
                                customer: {
                                  email:
                                    instance.storeProfile.account.accountEmail,
                                  business: {
                                    name: instance.storeProfile.account
                                      .accountName,
                                  },
                                  address: {
                                    countryCode:
                                      instance.storeProfile.company.countryCode,
                                    postalCode:
                                      instance.storeProfile.company.postalCode,
                                    city: instance.storeProfile.company.city,
                                  },
                                },
                                customData: {
                                  store_id: `${instance.store_id}`,
                                },
                              })
                          )
                        : undefined
                    }
                    target="_blank"
                  >
                    Start a trial
                  </Button>
                ) : (
                  <Button
                    variant="outline"
                    as="a"
                    href={
                      instance.subscription.management_urls
                        .update_payment_method
                    }
                    target="_blank"
                  >
                    Manage Billing Method
                  </Button>
                )
              ) : (
                <LoadingSpinner />
              )}
            </NavbarItem>
          </NavbarContent>
        </Navbar>
      }
    >
      <Box as="main" flex="1" py="2" px="4">
        <Container
          maxW="container.xl"
          pt="8"
          px="8"
          display="flex"
          flexDirection="column"
          margin="0 auto"
        >
          <Form onSubmit={() => {}}>
            <FormLayout>
              <Select
                name={"Enable?"}
                options={[
                  { label: "Enable", value: "true" },
                  { label: "Disable", value: "false" },
                ]}
                onChange={(value) => {
                  setEnabled(value === "true");
                }}
                value={isEnabled ? "true" : "false"}
              >
                <SelectButton />
                <SelectList />
              </Select>
              {/* <Field
                name="title"
                label="Title"
                value={config.titleText}
                onChange={(e: any) => {
                  setConfig({ ...config, titleText: e.target.value });
                }}
              />
              <Field
                name="description"
                label="Description"
                value={config.descText}
                onChange={(e: any) => {
                  setConfig({ ...config, descText: e.target.value });
                }}
              />
              <Field
                name="buttonLabel"
                label="Button Label"
                value={config.btnText}
                onChange={(e: any) => {
                  setConfig({ ...config, btnText: e.target.value });
                }}
              /> */}

              <Button
                disabled={instance?.subscription ? false : true}
                onClick={() =>
                  snackbar.promise(setSettings(isEnabled), {
                    loading: "Checking your website ...",
                    success: "The website is now with Readable: WCAG Accessibility!",
                    error: "Something went wrong, please try again.",
                  })
                }
              >
                {instance?.subscription
                  ? isEnabled
                    ? "Save Changes & Enable"
                    : "Save Changes & Disable"
                  : "Start a trial to enable"}
              </Button>
            </FormLayout>
          </Form>
          <Box mt={8}>
            <FeatureDescription />
          </Box>
        </Container>
      </Box>
    </AppShell>
  );
}

export default App;
